// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"f22c7490","304":"4df30abd","395":"309f1ab6","977":"f23020ae"}[chunkId] + ".chunk.js";
};